export default function blockImageSlider() {
  const sliders = document.querySelectorAll('.image-slider:not(.image-slider--disabled)');
  if (sliders.length === 0) return;
  return import('swiper/bundle').then(({default: Swiper}) => {
    sliders.forEach(function (slider) {
      const sliderItems = slider.querySelectorAll('.image-slider__item');

      const swiper = new Swiper(slider, {
        speed: 1000,
        loop: sliderItems.length > 1,
        slidesPerView: 1,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: slider.querySelector('.image-slider__arrow--next'),
          prevEl: slider.querySelector('.image-slider__arrow--prev'),
        },

      });
    });
  });
}